export default __webpack_public_path__ + "static/media/decimal.becf062d.svg";